"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomHouseSize = exports.getLevelArrayIdx = exports.houseSizeGenerators = exports.createHugeHouse = exports.createLargeHouse = exports.createMediumHouse = exports.createSmallHouse = exports.createTinyHouse = exports.createRoom = void 0;
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueMonofont_1 = require("../monofont/rogueMonofont");
var createRoom = function (name, abbreviation, options) {
    var _a, _b, _c, _d, _e;
    var color = rando_sidecar_1.rando.sample(rogueMonofont_1.rainbowScale);
    return {
        x: -1,
        y: -1,
        w: 0,
        h: 0,
        name: name,
        abbreviation: abbreviation,
        color: color,
        stuckFor: 0,
        minW: options.minW || 1,
        maxW: options.maxW || 10,
        numWindows: (_a = options.numWindows) !== null && _a !== void 0 ? _a : 2,
        minDoors: (_b = options.minDoors) !== null && _b !== void 0 ? _b : 1,
        numExternalDoors: (_c = options.numExternalDoors) !== null && _c !== void 0 ? _c : 0,
        numInternalDoors: (_d = options.numInternalDoors) !== null && _d !== void 0 ? _d : 1,
        isValid: false,
        askToShrink: 0,
        askToMove: 0,
        numToilets: (_e = options.numToilets) !== null && _e !== void 0 ? _e : 0,
    };
};
exports.createRoom = createRoom;
var createBathroom = function () {
    return (0, exports.createRoom)('bathroom', 'ba', {
        minW: 2,
        maxW: 4,
        numWindows: 0,
        numToilets: 1,
    });
};
var createBedroom = function () {
    return (0, exports.createRoom)('bedroom', 'bed', { minW: 3, maxW: 6 });
};
var createKitchenette = function () {
    return (0, exports.createRoom)('kitchenette', 'kitc', {
        minW: 2,
        maxW: 5,
        numExternalDoors: 1,
        numInternalDoors: 2,
    });
};
var createKitchen = function () {
    return (0, exports.createRoom)('kitchen', 'kitc', {
        minW: 5,
        maxW: 8,
        numExternalDoors: 1,
        numInternalDoors: 2,
    });
};
var createLivingRoom = function () {
    return (0, exports.createRoom)('living room', 'liv', {
        minW: 2,
        maxW: 5,
        numWindows: 4,
        numInternalDoors: 2,
    });
};
var createDen = function () {
    return (0, exports.createRoom)('den', 'den', {
        minW: 2,
        maxW: 4,
        numWindows: 2,
        numInternalDoors: 2,
    });
};
var createGarage = function () {
    return (0, exports.createRoom)('garage', 'gar', {
        minW: 6,
        maxW: 10,
        numWindows: 0,
        numExternalDoors: 1,
    });
};
var createStairs = function () {
    return (0, exports.createRoom)('stairs', 'st', { minW: 2, maxW: 3, numWindows: 0 });
};
// const create = () => {
// return createRoom('entry', 'en', { minW: 3 })
// }
var createEntry = function () {
    return (0, exports.createRoom)('entry', 'en', { minW: 2, maxW: 5, numExternalDoors: 1 });
};
// rooms.push(createKitchen())
// rooms.push(createBedroom())
// rooms.push(createBedroom())
// rooms.push(createBedroom())
// rooms.push(createBedroom())
// rooms.push(createBathroom())
// rooms.push(createBathroom())
// rooms.push(createGarage())
// rooms.push(createStairs())
// rooms.push(createEntry())
var createTinyHouse = function (difficulty) {
    return {
        houseSizeName: 'Tiny',
        makeRooms: function () {
            return [
                createBathroom(),
                createBedroom(),
                createKitchenette(),
                // createGarage(),
                // createStairs(),
                createEntry(),
            ];
        },
        w: 10,
        h: 10,
        hp: 1,
        maxHp: 6,
        rooms: [],
        difficulty: difficulty,
    };
};
exports.createTinyHouse = createTinyHouse;
var createSmallHouse = function (difficulty) {
    return {
        houseSizeName: 'Small',
        makeRooms: function () {
            return [
                createBathroom(),
                createBedroom(),
                createBedroom(),
                createKitchen(),
                createLivingRoom(),
                // createGarage(),
                // createStairs(),
                createEntry(),
            ];
        },
        w: 15,
        h: 12,
        hp: 1,
        maxHp: 7,
        rooms: [],
        difficulty: difficulty,
    };
};
exports.createSmallHouse = createSmallHouse;
var createMediumHouse = function (difficulty) {
    return {
        houseSizeName: 'Medium',
        makeRooms: function () {
            return [
                createBathroom(),
                createBedroom(),
                createBedroom(),
                createBedroom(),
                createKitchen(),
                createLivingRoom(),
                createGarage(),
                createEntry(),
            ];
        },
        w: 20,
        h: 15,
        hp: 1,
        maxHp: 9,
        rooms: [],
        difficulty: difficulty,
    };
};
exports.createMediumHouse = createMediumHouse;
var createLargeHouse = function (difficulty) {
    return {
        houseSizeName: 'Large',
        makeRooms: function () {
            return [
                createBathroom(),
                //createBathroom(),
                createBedroom(),
                createBedroom(),
                createBedroom(),
                //createBedroom(),
                createKitchen(),
                createLivingRoom(),
                //createDen(),
                createGarage(),
                createEntry(),
            ];
        },
        w: 30,
        h: 15,
        hp: 1,
        maxHp: 11,
        rooms: [],
        difficulty: difficulty,
    };
};
exports.createLargeHouse = createLargeHouse;
var createHugeHouse = function (difficulty) {
    return {
        houseSizeName: 'McMansion',
        makeRooms: function () {
            return [
                createBathroom(),
                //createBathroom(),
                //createBathroom(),
                createBedroom(),
                createBedroom(),
                createBedroom(),
                createBedroom(),
                //createBedroom(),
                createKitchen(),
                createLivingRoom(),
                createDen(),
                createGarage(),
                //createGarage(),
                createEntry(),
                createEntry(),
            ];
        },
        w: 32,
        h: 15,
        hp: 1,
        maxHp: 13,
        rooms: [],
        difficulty: difficulty,
    };
};
exports.createHugeHouse = createHugeHouse;
exports.houseSizeGenerators = [
    exports.createTinyHouse,
    exports.createSmallHouse,
    exports.createMediumHouse,
    exports.createLargeHouse,
    exports.createHugeHouse,
];
var getLevelArrayIdx = function (arr, levelNum, levelAdjust) {
    var numItems = arr.length;
    var numLevels = 10;
    var base = (levelNum + levelAdjust) * (numItems / numLevels) - 1;
    base += rando_sidecar_1.rando.f(-1.5, 2.25);
    base = Math.round(base);
    base = mathUtils_sidecar_1.mathUtils.clamp(base, 0, numItems - 1);
    // console.log('base is', base, levelNum, levelAdjust, numItems)
    return arr[base];
};
exports.getLevelArrayIdx = getLevelArrayIdx;
var getRandomHouseSize = function (levelNum, levelAdjust) {
    return (0, exports.getLevelArrayIdx)(exports.houseSizeGenerators, levelNum, levelAdjust);
    // let numSizes = houseSizeGenerators.length
    // let numLevels = 10
    // let base = (levelNum + levelAdjust) * (numSizes / numLevels) - 1
    // base += rando.i(-1, 1)
    // base = mathUtils.clamp(base, 0, numSizes - 1)
    // return houseSizeGenerators[base]
};
exports.getRandomHouseSize = getRandomHouseSize;
